export default __webpack_public_path__ + "static/media/dead-pin.0e1ea61f.svg";